<div class="form-field">
  @if (name) {
    <label class="label" [class.bold]="bold" [attr.for]="inputId">{{name}}</label>
  }
  @if (control) {
    <div class="date-input">
      <input
        [id]="inputId"
        type="text"
        placeholder="DD/MM/YYYY"
        [formControl]="control"
        class="form-control"
        [readonly]="readonly"
        [matDatepicker]="datepicker"
        >
      <button type="button" class="toggle-button" (click)="openCalendar()"></button>
    </div>
  }

  @if (showError) {
    <div class="input-error">
      <span>{{errorPresentation}}</span>
    </div>
  }
</div>

<mat-datepicker #datepicker></mat-datepicker>
